function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from "react";
var SvgAmpSquare = function SvgAmpSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M2 9.2C2 6.67976 2 5.41965 2.49047 4.45704C2.9219 3.61031 3.61031 2.9219 4.45704 2.49047C5.41965 2 6.67976 2 9.2 2H14.8C17.3202 2 18.5804 2 19.543 2.49047C20.3897 2.9219 21.0781 3.61031 21.5095 4.45704C22 5.41965 22 6.67976 22 9.2V14.8C22 17.3202 22 18.5804 21.5095 19.543C21.0781 20.3897 20.3897 21.0781 19.543 21.5095C18.5804 22 17.3202 22 14.8 22H9.2C6.67976 22 5.41965 22 4.45704 21.5095C3.61031 21.0781 2.9219 20.3897 2.49047 19.543C2 18.5804 2 17.3202 2 14.8V9.2Z",
    fill: "#F343AD",
    style: _defineProperty(_defineProperty({
      fill: "#F343AD"
    }, "fill", "color(display-p3 0.9529 0.2627 0.6784)"), "fillOpacity", 1)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.66686 11.483L13.0926 6.06202C13.7872 5.36801 14.1345 5.021 14.3772 5.00217C14.5864 4.98594 14.7901 5.06179 14.909 5.20023C15.0471 5.36092 14.9381 5.79668 14.72 6.66818L13.5014 11.5384L15.4879 11.3239C16.2019 11.2468 16.5589 11.2082 16.739 11.3025C16.8953 11.3842 16.9924 11.5214 16.9998 11.6706C17.0082 11.8426 16.7832 12.0674 16.3331 12.517L10.9074 17.938C10.2128 18.632 9.86551 18.979 9.62275 18.9978C9.41361 19.0141 9.20994 18.9382 9.09097 18.7998C8.95287 18.6391 9.06191 18.2033 9.27998 17.3318L10.4986 12.4616L8.51206 12.6761C7.79812 12.7532 7.44115 12.7918 7.26096 12.6975C7.10469 12.6158 7.00755 12.4786 7.00023 12.3294C6.99179 12.1574 7.21681 11.9326 7.66686 11.483Z",
    fill: "url(#paint0_linear_2112_2271)",
    style: {}
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2112_2271",
    x1: 6.80289,
    y1: 18.7696,
    x2: 6.80289,
    y2: 5.23048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0047FF",
    style: _defineProperty(_defineProperty({
      stopColor: "#0047FF"
    }, "stopColor", "color(display-p3 0.0000 0.2800 1.0000)"), "stopOpacity", 1)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419774,
    stopColor: "#DB00FF",
    style: _defineProperty(_defineProperty({
      stopColor: "#DB00FF"
    }, "stopColor", "color(display-p3 0.8600 0.0000 1.0000)"), "stopOpacity", 1)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700",
    style: _defineProperty(_defineProperty({
      stopColor: "#FFC700"
    }, "stopColor", "color(display-p3 1.0000 0.7800 0.0000)"), "stopOpacity", 1)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700",
    style: _defineProperty(_defineProperty({
      stopColor: "#FFC700"
    }, "stopColor", "color(display-p3 1.0000 0.7800 0.0000)"), "stopOpacity", 1)
  }))));
};
export default SvgAmpSquare;